import { render, staticRenderFns } from "./StockViewSalesOrder.vue?vue&type=template&id=50c81c23&scoped=true"
import script from "./StockViewSalesOrder.vue?vue&type=script&lang=js"
export * from "./StockViewSalesOrder.vue?vue&type=script&lang=js"
import style0 from "./StockViewSalesOrder.vue?vue&type=style&index=0&id=50c81c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c81c23",
  null
  
)

export default component.exports